const routeSearch = () => '/search';

export default routeSearch;
